


<script>

/*



VUEX -> STORE.JS -> this.$store




*/

import BarList from '../components/bar-list'
import DestaqForm from './destaq-form'
import AnexosForm from '../components/anexos-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            destaq: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            showAnexosForm: false,
            coddestaq: '',
            descricao: ''
        }
    },

    computed: {
        destaqList: function () {
            return this.$store.getters.getDestaqList
        },
        nextPage: function () {
            return this.$store.getters.getNextPage
        }
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    methods: {
        getStatus(status) {
            if (status == '1')
              return 'Válida'
            else
            if (status == '3')
              return 'Vencida'
            else
            if (status == '2')
              return 'Não iniciada'
        },
        handleEdit (cod) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.coddestaq = cod
            this.showForm = true;
        },
        
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.coddestaq = ''
            this.showForm = true;
        },

        handleMore () {
            this.offset = 'offset=' + this.nextPage
            this.loadData()
        },

        closeForm() {
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"coddestaq":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {            
            this.$store.dispatch('loadDestaq', { filter: this.filter, page: this.nextPage } )            
            this.offset = ''
        },

        handleAnexosForm (coddestaq, descricao) {
            this.coddestaq = coddestaq
            this.descricao = descricao
            this.showAnexosForm = true
        },

        closeAnexosForm() {
            this.showAnexosForm = false
        }
    },

    components: {
        BarList, DestaqForm, AnexosForm
    },

    created () {
        this.showForm = false
        this.loadData()
    },

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false" 
                :xls-button="false"
                single-entity="Item em Destaque" 
                plural-entity="Itens em Destaque"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pela descrição">
            </bar-list>

            <div class="default-container nb-card-list">
                <alert v-if="destaqList.length == 0" type="norecord"></alert>

                <article class="nb-card" v-for="destaq in destaqList" :key="destaq.coddestaq">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <button type="button" class="nb-card-image" :aria-label="'Gerenciar imagem de ' + destaq.descricao"
                                title="Gerenciar imagem" @click="handleAnexosForm(destaq.coddestaq, destaq.descricao)">
                                <img v-if="destaq.url" :src="destaq.url" alt="">
                                <i v-else class="fa fa-camera" aria-hidden="true"></i>
                                <span class="nb-card-image-edit"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                            </button>

                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ destaq.descricao }}</h2>
                                    <span class="nb-card-badge" :class="destaq.status == 'A' ? 'nb-card-badge--success' : 'nb-card-badge--inactive'">
                                        {{ getStatus(destaq.status) }}
                                    </span>
                                </div>
                                <div class="nb-card-code" v-if="destaq.coddestaq">
                                    Código <strong>{{ destaq.coddestaq }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid 
                                :options="{ barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar' }" 
                                :moreActions="[]" 
                                @edit="handleEdit(destaq.coddestaq)">
                            </bar-grid>
                        </div>
                    </div>

                    <div class="nb-card-details">
                        <div class="nb-card-detail">
                            <span class="nb-card-detail-label">Vigência (Início à Término)</span>
                            <strong>{{ destaq.dtinicio | formatData }} à {{ destaq.dttermino | formatData }}</strong>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        
        <destaq-form v-if="showForm" :index="this.coddestaq" :crud="this.crud" @closeform="closeForm"></destaq-form>
        <anexos-form v-if="showAnexosForm" :params="{ ref: 'destaq', chaveref: coddestaq, title: descricao, showform: true }" @closeform="closeAnexosForm"></anexos-form>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-image {
  position: relative;
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: #64748b;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
}

.nb-card-image:focus-visible {
  outline: 2px solid #004e94;
  outline-offset: 2px;
}

.nb-card-image > img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.nb-card-image > .fa {
  font-size: 19px;
}

.nb-card-image-edit {
  position: absolute;
  right: -5px;
  bottom: -5px;
  display: flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #004e94;
  border: 2px solid #fff;
  border-radius: 50%;
  font-size: 8px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.nb-card-badge--success {
  color: #166534;
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.nb-card-badge--inactive {
  color: #92400e;
  background: #fffbeb;
  border-color: #fde68a;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-card-details {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  margin: 12px 0 0 60px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-card-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-card-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-card-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }

  .nb-card-details {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/destaq-list.vue